<template>
  <div
    class="modal fade fill-in disable-scroll"
    id="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="false"
    style="z-index: 9999"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-confirm modal-lebar modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="card shade">
            <div class="card-header d-flex">
              <div class="h4">Advance Search</div>
              <div
                class="shade ml-auto clickable hoverable bg-white"
                style="
                  margin-right: -30px;
                  margin-top: -25px;
                  height: 2rem;
                  width: 2rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                data-dismiss="modal"
                @click="closeModal"
              >
                <i class="bi bi-x" style="font-size: 30px"></i>
              </div>
            </div>
            <div class="card-body mt-3">
              <form @submit.prevent="startSearch()">
                <!-- field kata dicari -->
                <div class="form-group">
                  <label for="kata-dicari">Kata yang di Cari :</label>
                  <input
                    type="text"
                    id="kata-dicari"
                    placeholder="Masukkan kata yang anda cari..."
                    class="form-control rounded-lg"
                    v-model="q"
                    style="height:2.55rem"
                  />
                </div>
                <!-- field kata di exclude -->
                <div class="form-group">
                  <label for="kata-exclude">Kata yang di Exclude :</label>
                  <input
                    type="text"
                    id="kata-exclude"
                    placeholder="Masukkan kata yang anda exlcude..."
                    class="form-control rounded-lg"
                    v-model="excludes"
                    style="height:2.55rem"
                  />
                  <small class="text-muted">
                    <i class="bi bi-info-circle"></i> Jika kata lebih dari satu,
                    pisahkan dengan koma
                  </small>
                </div>
                <!-- field account / media -->
                <div class="form-group">
                  <label for="account-media">Account/Media :</label>
                  <input
                    type="text"
                    id="account-media"
                    placeholder="Masukkan knama account atau nama media..."
                    class="form-control rounded-lg"
                    v-model="account"
                    style="height:2.55rem"
                  />
                </div>
                <!-- field cakupan media -->
                <div class="form-group">
                  <label for="jenis-media">Cakupan Media :</label>
                  <div class="input-group input-group-right mb-3">
                    <select
                      id="jenis-media"
                      class="form-control"
                      v-model="cakupan"
                      style="height:2.55rem"
                    >
                      <option value="all">Tampilkan Semua</option>
                      <option value="nasional">
                        Media Nasional
                      </option>
                      <option value="internasional">
                        Media Internasional
                      </option>
                    </select>
                    <div class="input-group-append">
                      <span
                        class="input-group-text bg-transparent"
                        id="basic-addon1"
                      >
                        <i class="bi bi-flag"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- field sorting -->
                <div class="form-group">
                  <label for="sorting">Sorting :</label>
                  <div class="input-group input-group-right mb-3">
                    <select
                      id="sorting"
                      class="form-control"
                      v-model="sort"
                      style="height:2.55rem"
                    >
                      <option value="esmr">Terpopuler</option>
                      <option value="date">Terbaru</option>
                      <option value="dateOld">Terlama</option>
                      <option value="engagement">Engagement</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text bg-transparent">
                        <i class="bi bi-sort-down-alt"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- field jenis media -->
                <div class="form-group">
                  <label for="jenis-media">Jenis Media :</label>
                  <div class="input-group input-group-right mb-3">
                    <select
                      id="jenis-media"
                      class="form-control"
                      v-model="pers"
                      style="height:2.55rem"
                    >
                      <option value="2">Tampilkan Semua</option>
                      <option value="1">Tampilkan Pers</option>
                      <option value="0">Tampilkan Non Pers</option>
                    </select>
                    <div class="input-group-append">
                      <span
                        class="input-group-text bg-transparent"
                        id="basic-addon1"
                      >
                        <i class="bi bi-eye"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- field tier -->
                <div class="form-group">
                  <label for="tier">Tier :</label>
                  <div class="input-group input-group-right mb-3">
                    <multiselect
                      v-model="multiple_tier"
                      :options="tier_options"
                      :multiple="true"
                      :searchable="false"
                      placeholder="Semua Tier"
                      label="name"
                      track-by="name"
                      @input="tierChanged"
                    >
                    </multiselect>
                  </div>
                </div>
                <input
                  type="submit"
                  class="btn btn-success float-right"
                  value="Cari"
                />
                <input
                  type="reset"
                  class="btn btn-danger float-right mr-2"
                  value="Batal"
                  @click="cancelSearch"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Multiselect from "vue-multiselect";

export default {
  name: "modal_advance_search",
  components: { Multiselect },
  data() {
    return {
      multiple_tier:
        "tier" in this.$route.query
          ? this.setInitialTier(this.$route.query.tier)
          : [],
      tier_options: [
        { name: "Tier 1", value: "1" },
        { name: "Tier 2", value: "2" },
        { name: "Tier 3", value: "3" },
        { name: "Tier 4", value: "4" },
      ],
      queries: this.$route.query,
      q: this.$route.query.q ? this.$route.query.q : null,
      excludes: this.$route.query.excludes
        ? this.$route.query.excludes.replaceAll("|", ",")
        : null,
      account: this.$route.query.account ? this.$route.query.account : null,
      cakupan: this.$route.query.cakupan ? this.$route.query.cakupan : "all",
      sort: this.$route.query.sort ? this.$route.query.sort : "date",
      pers: this.$route.query.pers ? this.$route.query.pers : "2",
      tier: this.$route.query.tier ? this.$route.query.tier : "0",
    };
  },
  methods: {
    setInitialTier(tier) {
      const result = tier.split(",").map((value) => ({
        name: `Tier ${value}`,
        value: value,
      }));
      return result;
    },
    tierChanged() {
      const result = this.multiple_tier.map((item) => item.value).join(",");
      if (result) {
        this.tier = result;
      } else {
        this.tier = "0";
      }
    },
    startSearch: function() {
      let params = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      if (this.q && this.q != " ") {
        params.q = this.q;
      }
      if (this.excludes && this.excludes != "") {
        let exc = this.excludes.replaceAll(",", "|");
        params.excludes = exc;
      }
      if (this.account) {
        let acc = this.account.replaceAll("@", "");
        params.account = acc;
      }
      if (this.cakupan != "all") {
        params.cakupan = this.cakupan;
      }
      if (this.sort) {
        params.sort = this.sort;
      }
      if (this.pers != "2") {
        params.pers = this.pers;
      }
      if (this.tier != 0) {
        params.tier = this.tier;
      }
      if (
        this.queries.q != params.q ||
        this.queries.excludes != params.excludes ||
        this.queries.account != params.account ||
        this.queries.cakupan != params.cakupan ||
        this.queries.sort != params.sort ||
        this.queries.pers != params.pers ||
        this.queries.tier != params.tier
      ) {
        this.$router.replace({
          query: params,
        });
      }

      this.$parent.show_modal_advance = false;
      $("#modal").modal("hide");
    },
    closeModal: function() {
      // var $trigger = $(".modal-lebar");
      // if ($trigger !== event.target && !$trigger.has(event.target).length) {
      this.$parent.show_modal_advance = false;
      // }
    },
    cancelSearch: function() {
      this.$parent.show_modal_advance = false;
      $("#modal").modal("hide");
    },
  },
  mounted: function() {
    $("#modal").modal("show");
  },
};
</script>

<style scoped>
.user-pic {
  width: 180px !important;
  height: 180px !important;
  position: relative;
}
.img-circle {
  height: 180px !important;
  width: 180px !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}
.propic-badge {
  position: relative;
  right: 15%;
  left: 20%;
  top: -9%;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 3px;
  width: 15%;
  height: 15%;
  max-width: 100%;
}
.background-image-post {
  background: -webkit-linear-gradient(#bc1888, #f09433);
  background-blend-mode: lighten;
  width: 500px;
  height: 600px;
  max-width: 800px;
}
.img-post {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.account-name {
  position: relative;
  bottom: 10px;
  left: 50px;
  font-size: 90%;
}
.subtitle {
  position: relative;
  left: 55px;
  bottom: 14px;
  font-size: 90%;
}
#content {
  min-height: 100px;
  max-height: 400px;
  overflow-y: scroll;
}
.modal.fade.fill-in > .close > i {
  font-size: 60px;
}
.modal-lebar {
  width: 70% !important;
}
.modal-number {
  font-size: 25px;
  color: black !important;
}
.content-post {
  max-height: 500px;
  max-width: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  direction: ltr;
  scrollbar-color: #d4aa70 #e4e4e4;
  scrollbar-width: thin;
}
.content-post::-webkit-scrollbar-thumb {
  background-image: linear-gradient(180deg, #d0368a 0%, #708ad4 99%);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
  border-radius: 100px;
}
.content-post::-webkit-scrollbar {
  width: 10px;
}
.content-post::-webkit-scrollbar-track {
  background-color: #e4e4e4;
  border-radius: 100px;
}
.content-post::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background-image: linear-gradient(180deg, #bc1888, #f09433);
  box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
}
</style>
